import SearchParamsBase from '../../../Elements/SearchParamsBase';

export default class EvaluatorLeadReportSearchParams extends SearchParamsBase {
  static saveType = 'EvaluatorLeadReportSearchParams';
  initialize() {
    this.UploadNewLeadList = '';
    this.LeadListFile = null;
    this.RegistrationDateFrom = null;
    this.RegistrationDateTo = null;
    this.LeadDateFrom = null;
    this.LeadDateTo = null;
    this.Form = null;
    this.OfficeIds = [];
    this.CountryIds = [];
  }
}
